import React, { useState, useEffect } from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import Navbar from './common/Navbar';
import Footer from './common/Footer';
import Breadcrumb from './common/Breadcrumb';
import Loader from './common/Loader';
import ProductCard from './common/ProductCard';
import { getOfferProducts } from '../services/api';

const Offers = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const response = await getOfferProducts();
        if (response.data.data) {
          setProducts(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching offer products:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchOffers();
  }, []);

  if (loading) {
    return <Loader message="Loading offers..." />;
  }

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#faf8f5' }}>
      <Navbar />

      {/* Header Banner */}
      <Box
        sx={{
          py: 5,
          background: 'linear-gradient(135deg, #ff6b35 0%, #f7c948 100%)',
          textAlign: 'center',
          color: '#fff',
        }}
      >
        <Container maxWidth="md">
          <LocalOfferIcon sx={{ fontSize: 48, mb: 1 }} />
          <Typography variant="h3" fontWeight={800} sx={{ fontSize: { xs: '1.8rem', md: '2.5rem' } }}>
            Festival Special Offers
          </Typography>
          <Typography sx={{ opacity: 0.9, mt: 1 }}>
            {products.length} products on offer
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Breadcrumb items={[{ label: 'Offers' }]} />

        {products.length > 0 ? (
          <Grid container spacing={3} sx={{ mt: 1 }}>
            {products.map((product) => (
              <Grid
                item
                xs={6}
                sm={6}
                md={3}
                key={product._id}
                sx={{ display: 'flex', justifyContent: 'center' }}
              >
                <ProductCard product={product} />
              </Grid>
            ))}
          </Grid>
        ) : (
          <Box sx={{ textAlign: 'center', py: 8 }}>
            <LocalOfferIcon sx={{ fontSize: 80, color: '#ddd', mb: 2 }} />
            <Typography variant="h5" gutterBottom>
              No offers available right now
            </Typography>
            <Typography color="text.secondary">
              Check back later for exciting deals!
            </Typography>
          </Box>
        )}
      </Container>

      <Footer />
    </Box>
  );
};

export default Offers;
